import * as requestsApi from "../network/apis/requests";
import { companyPermissionModules } from "./Constants";
import { canViewCompanyModules } from "./Permissions";

export const getRequestsListByPortal = (portal) =>
  portal === "company"
    ? requestsApi.getCompanyPortalRequestsList
    : requestsApi.getRequestsList;

/**
 * A company employee lists an event's joining requests only with the Joining Events
 * permission, which editing events doesn't grant; the backend refuses it otherwise.
 */
export const canListEventRequests = (portal, login) =>
  portal !== "company" ||
  canViewCompanyModules(companyPermissionModules.joiningEvents, login);
